// import { bootstrapApplication } from '@angular/platform-browser';
// import { appConfig } from './app/app.config';
// import { AppComponent } from './app/app.component';

// bootstrapApplication(AppComponent, appConfig)
//   .catch((err) => console.error(err));

import { bootstrapApplication } from "@angular/platform-browser";
import { AppComponent } from "./app/app.component";
import { appConfig } from "./app/app.config";
import { environment } from "./environments/environment";
import { ClarityService } from "./app/shared/services";
const isProduction = environment.production;

// Global error handling to prevent blank screens
// window.addEventListener("unhandledrejection", (event) => {
//     console.error("Unhandled promise rejection:", event.reason);
//     // Prevent the default browser behavior
//     event.preventDefault();
// });

// window.addEventListener("error", (event) => {
//     console.error("Global error:", event.error);
//     // Prevent the default browser behavior
//     event.preventDefault();
// });

if ("serviceWorker" in navigator) {
    navigator.serviceWorker
        .register("/firebase-messaging-sw.js") // prod firebase app
        .then((registration) => {
            console.log(
                "✅ Service Worker ",
                isProduction ? "production" : "test",
                " registered successfully:",
                registration,
            );
        })
        .catch((error) => {
            console.error("❌ Service Worker registration failed:", error);
        });
}

bootstrapApplication(AppComponent, appConfig)
    .then((appRef) => {
      const clarityService = appRef.injector.get(ClarityService)
      clarityService.init();
    })
    .catch((err) => {
        console.error("❌ Application bootstrap failed:", err);
        // Show user-friendly error message
        // document.body.innerHTML = `
        //     <div style="display: flex; justify-content: center; align-items: center; height: 100vh; font-family: Arial, sans-serif;">
        //         <div style="text-align: center; padding: 20px;">
        //             <h2>Application Error</h2>
        //             <p>Something went wrong while loading the application.</p>
        //             <button onclick="window.location.reload()" style="padding: 10px 20px; background: #007bff; color: white; border: none; border-radius: 5px; cursor: pointer;">
        //                 Reload Application
        //             </button>
        //         </div>
        //     </div>
        // `;
    });

// Robust recovery for lazy chunk load failures that can cause white screens
// Reload once if a chunk fails to load (likely due to SW version mismatch)
(function setupChunkLoadRecovery() {
    const RELOAD_FLAG_KEY = "__chunk_reload_once__";
    function shouldHandleChunkError(message: string) {
        return /Loading chunk [^ ]+ failed|ChunkLoadError|ERR_CHUNK_LOAD_FAILED/i.test(message);
    }

    window.addEventListener("error", (event: ErrorEvent) => {
        const message = event?.message || event?.error?.message || "";
        if (message && shouldHandleChunkError(message)) {
            const alreadyReloaded = sessionStorage.getItem(RELOAD_FLAG_KEY) === "1";
            if (!alreadyReloaded) {
                sessionStorage.setItem(RELOAD_FLAG_KEY, "1");
                window.location.reload();
            } else {
                sessionStorage.removeItem(RELOAD_FLAG_KEY);
            }
        }
    });

    window.addEventListener("unhandledrejection", (event: PromiseRejectionEvent) => {
        const reason: any = event?.reason;
        const message = (typeof reason === "string" ? reason : reason?.message) || "";
        if (message && shouldHandleChunkError(message)) {
            const alreadyReloaded = sessionStorage.getItem(RELOAD_FLAG_KEY) === "1";
            if (!alreadyReloaded) {
                sessionStorage.setItem(RELOAD_FLAG_KEY, "1");
                window.location.reload();
            } else {
                sessionStorage.removeItem(RELOAD_FLAG_KEY);
            }
        }
    });
})();
